import { SharingTipId } from '../types/sharingTipId';
import { logUsage } from 'owa-analytics';

const forAnalyticsOnlyIdToSharingIssueMap = new Map<string, SharingTipId[]>();

export function logSharingTipChangesForLink(linkId: string, newSharingTips: SharingTipId[]) {
    let previousSharingTips: SharingTipId[] = [];
    if (forAnalyticsOnlyIdToSharingIssueMap.has(linkId)) {
        previousSharingTips = forAnalyticsOnlyIdToSharingIssueMap.get(linkId);
    }

    logSharingTipsDatapoints(previousSharingTips, newSharingTips, linkId);
    forAnalyticsOnlyIdToSharingIssueMap.set(linkId, newSharingTips);
}

export function logSharingTipChangesForLinkRemoval(linkId: string) {
    let previousSharingTips: SharingTipId[] = [];
    if (forAnalyticsOnlyIdToSharingIssueMap.has(linkId)) {
        previousSharingTips = forAnalyticsOnlyIdToSharingIssueMap.get(linkId);
    }
    logSharingTipsDatapoints(previousSharingTips, [] /* newSharingTips */, linkId, 'deleteLink');
}

function logSharingTipsDatapoints(
    previousSharingTips: string[],
    newSharingTips: string[],
    linkId: string,
    actionSource: string | null = null
) {
    const addedSharingTips: string[] = newSharingTips.filter(
        id => previousSharingTips.indexOf(id) === -1
    );
    const removedSharingTips: string[] = previousSharingTips.filter(
        id => newSharingTips.indexOf(id) === -1
    );

    const source: string = !!actionSource ? actionSource : 'UnknownActionSource';
    addedSharingTips.unshift(source);
    removedSharingTips.unshift(source);

    if (addedSharingTips.length > 1) {
        logUsage('LinkSharingTipsAdded', addedSharingTips, { cosmosOnlyData: linkId });
    }
    if (removedSharingTips.length > 1) {
        logUsage('LinkSharingTipsRemoved', removedSharingTips, { cosmosOnlyData: linkId });
    }
}
